export default "__VITE_ASSET__bwSkmH6M__"